"use client";

import React, { useState, useRef } from "react";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
function BlogListConsumer() {
  const {
    posts,
    loading,
    error,
    hasNext,
    loadMore,
    isRefetching
  } = usePosts();
  const [hoveredPost, setHoveredPost] = useState<any | null>(null);
  const [mousePos, setMousePos] = useState({
    x: 0,
    y: 0
  });
  const containerRef = useRef<HTMLDivElement>(null);
  const handleMouseMove = (e: React.MouseEvent) => {
    if (!containerRef.current) return;
    const rect = containerRef.current.getBoundingClientRect();
    setMousePos({
      x: e.clientX - rect.left,
      y: e.clientY - rect.top
    });
  };
  if (loading && posts.length === 0) {
    return <div className="w-full flex flex-col border-t border-border">
        {[...Array(4)].map((_, i) => <div key={i} data-index={i} className="py-12 border-b border-border flex items-center justify-between animate-pulse">
            <div className="w-1/4 h-4 bg-muted/20 rounded-md"></div>
            <div className="w-1/2 h-12 bg-muted/20 rounded-md"></div>
            <div className="w-12 h-12 rounded-lg bg-muted/20"></div>
          </div>)}
      </div>;
  }
  if (error) {
    return <div className="text-destructive py-12 text-center font-sans">
        Failed to load moving resources.
      </div>;
  }
  if (posts.length === 0) {
    return <div className="text-muted-foreground py-12 text-center font-sans">
        No moving guides available at the moment.
      </div>;
  }
  return <div ref={containerRef} className="relative w-full" onMouseMove={handleMouseMove} onMouseLeave={() => setHoveredPost(null)}>
      <div className="flex flex-col border-t border-border">
        {posts.map((post, i) => <Link key={post.id} to={post.link || "#"} data-index={i} className="group flex flex-col md:flex-row md:items-center justify-between py-10 md:py-14 border-b border-border hover:bg-accent/50 transition-colors duration-300 relative z-10" onMouseEnter={() => setHoveredPost(post)}>
            {}
            <div className="flex items-center gap-4 md:w-1/4 text-xs md:text-sm text-muted-foreground uppercase tracking-widest font-default mb-4 md:mb-0">
              <span>
                {post.date ? new Date(post.date).toLocaleDateString("en-US", {
              month: "short",
              day: "numeric",
              year: "numeric"
            }) : "Recent"}
              </span>
              {post.categories && post.categories.length > 0 && <>
                  <span className="w-1 h-1 rounded-lg bg-primary"></span>
                  <span className="text-primary font-semibold">{post.categories[0].name}</span>
                </>}
            </div>

            {}
            <div className="md:w-1/2 pr-8">
              <h3 className="text-3xl md:text-5xl lg:text-6xl font-default font-bold tracking-tight group-hover:text-primary transition-colors duration-300 line-clamp-2">
                {post.title}
              </h3>
            </div>

            {}
            <div className="md:w-1/4 flex justify-start md:justify-end mt-6 md:mt-0">
              <div className="w-14 h-14 rounded-lg border border-border flex items-center justify-center group-hover:bg-primary group-hover:border-primary group-hover:text-primary-foreground transition-all duration-300 shadow-sm">
                <ArrowRight className="w-6 h-6 -rotate-45 group-hover:rotate-0 transition-transform duration-300" />
              </div>
            </div>
          </Link>)}
      </div>

      {}
      {hasNext && <div className="mt-16 flex justify-center">
          <Button variant="outline" size="lg" onClick={async () => await loadMore()} disabled={isRefetching} className="rounded-lg px-12 py-6 text-sm uppercase tracking-widest font-default font-bold hover:bg-primary hover:text-primary-foreground hover:border-primary transition-all shadow-md">
            {isRefetching ? "Updating..." : "View More Guides"}
          </Button>
        </div>}
    </div>;
}
export default function MovingInsights() {
  const wp_query_params = {
    post_type: "post",
    per_page: 5
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section data-section-id="223695" id="moving-insights" className="bg-background text-foreground py-24 md:py-32 px-6 md:px-12 lg:px-24 overflow-hidden">
      <div className="max-w-screen-2xl mx-auto">
        <div className="mb-20">
          <h2 className="text-5xl md:text-7xl lg:text-8xl font-default font-bold uppercase tracking-tighter leading-none">
            Moving <br />
            <span className="text-primary">& Insights</span>
          </h2>
        </div>
        
        <PostsProvider wp_query={{
        post_type: "post",
        per_page: 5
      }}>
          <BlogListConsumer />
        </PostsProvider>
      </div>
    </section>;
}